import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findTipsContentByTipsId (params) {
    return axios.post(global.CMS_BASE + '/tips/findTipsContentByTipsId', params)
  }
}



// WEBPACK FOOTER //
// ./src/request/cms/tips.js